let idCount = 0;

/**
 * Dead simple unique ID implementation.
 * Thanks lodash!
 * @return {number}
 */
function uniqueId() {
  return ++idCount;
}

export default uniqueId;



// WEBPACK FOOTER //
// ./components/v-components/vue-select2/utility/uniqueId.js